import { AuthService } from '../../../../services/auth/auth.service';
import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { SuccessSnackbar } from '../../../../components/snackbar/success-snackbar/success-snackbar';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.html',
  styleUrls: ['./callback.scss']
})
export class Callback implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly snackbar: MatSnackBar
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (this.authService.tokenIsValid(token)) {
        this.authService.setToken(token)
        this.router.navigate(['/'])
      } else {
        this.router.navigate(['/auth/login'])
        this.snackbar.open('Token inválido, tente novamente.')
      }
    });
  }
}
